import { ENDPOINTS } from "../config/api-config";
import axiosIns from "../common/interceptor/axios-interceptor";
import logger from "../helpers/logger";

const openAIService = {
  /**
   * Send a message to the AI chatbot with optional conversation history
   * @param {string} message - The user's message
   * @param {Array} conversationHistory - Optional array of previous messages for context
   * @returns {Promise<string>} The AI response message
   */
  async sendMessage(message, conversationHistory = []) {
    try {
      // Format conversation history for the API
      const formattedHistory = conversationHistory
        .filter(msg => !msg.isGreeting) // Exclude greeting messages from history
        .map(msg => ({
          text: msg.text,
          isUser: msg.isUser
        }));

      const response = await axiosIns.post(
        `${ENDPOINTS.OPENAI_CHAT}`,
        {
          message: message,
          conversationHistory: formattedHistory
        },
        {
          headers: {
            "Content-Type": "application/json"
          }
        }
      );

      return response.data.message;
    } catch (error) {
      logger.error("Error calling OpenAI API:", error);
      throw new Error("Failed to get response from AI assistant");
    }
  },
};

export default openAIService;
